export const aboutData = {
    description: 'and I am a fullstack developer located in Göteborg, Sweden. With a background in Interior Design from Academy of Fine Arts in Warsaw, I bring the unique blend of creativity and technical expertise to my projects. My passion for UI design allowed me to develop an eye for detail that helps me create visually appealing websites and applications.',
    other: [
        {
            id: 1,
            title: 'broke polish squat record with 176 kg',
            link: 'https://www.instagram.com/p/CQYB7vcgyBI/?igsh=MWttbmFtYjBzYmllZw=='
        },
        {
            id: 2,
            title: 'took photos in a coffee can',
            link: ''
        },
        {
            id: 3,
            title: 'love to swim in any water temperature',
            link: ''
        },
    ]
}
